import React from 'react';

import LoadingSection from 'components/LoadingSection';
import { Layout } from 'layouts/Layout';

type Props = {
  delay?: number;
  navSection?: 'MAIN' | 'STAFF';
};

export function LoadingPage({ delay, navSection }: Props) {
  return (
    <Layout navSection={navSection}>
      <LoadingSection delay={delay} />
    </Layout>
  );
}
